import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header"
const getPartyContactDetails = (state) => {
 
  return axios.get(API + "parties/edit-contact/"+state+"/",{headers: authHeader(),});
};
const editPartyContactDetails = (state, prefix, first_name,middle_name,last_name,phone_number,mobile_number,email,createpartyuser) => {
    return axios.post(API + "parties/edit-contact/" +state+"/", {
        state,
        prefix,
        first_name,
        middle_name,
        last_name,
        phone_number,
        mobile_number,
        email,
        createpartyuser
    },{headers: authHeader(),});
  };
const EditContactService = {
    getPartyContactDetails,
    editPartyContactDetails,
  };
  export default EditContactService;